import React from 'react';
import { useEntitlement } from '../../hooks/useEntitlement';

/**
 * Small tier tag (paywall bridge): Free / Pro / Premium / Pro trial. Styled
 * by `.tier-badge` (trader theme): a quiet label, not a pill.
 */
interface Props {
  /** Append "· Nd" trial countdown when on trial. */
  showTrialDays?: boolean;
  style?: React.CSSProperties;
}

const TierBadge: React.FC<Props> = ({ showTrialDays = false, style }) => {
  const { label, isTrialing, trialDaysLeft } = useEntitlement();
  const text =
    showTrialDays && isTrialing && trialDaysLeft != null
      ? `${label} · ${trialDaysLeft}d`
      : label;
  const tone = label === 'Free' ? 'free' : label === 'Premium' ? 'premium' : 'pro';

  return <span className={`tier-badge is-${tone}`} style={style}>{text}</span>;
};

export default TierBadge;
